import React from "react";
import AuthedRoutes from "./Routs/AuthedRoutes";
import UnAuthedRoutes from "./Routs/UnAuthedRoutes";
import LazyAuthedRoutes from "./Routs/LazyAuthedRoutes";
export default ({ token }) => (token ? <LazyAuthedRoutes /> : <UnAuthedRoutes />);
